import { ACCOUNT_SELLER_STATUS } from '../../constants/service/app/accountSellerConstants';

/**
 *  판매점 상태가 가입요청 상태이고 거절 이력이 있으면 재가입요청 상태로 설정
 */
export const setStoreStatus = (status, rejectCnt) => {
  if (status === ACCOUNT_SELLER_STATUS.REQUEST && rejectCnt > 0) {
    return ACCOUNT_SELLER_STATUS.RE_REQUEST;
  } else {
    return status;
  }
};
